import { render, staticRenderFns } from "./campaign-detail.vue?vue&type=template&id=e0813f3e&scoped=true"
import script from "./campaign-detail.vue?vue&type=script&lang=js"
export * from "./campaign-detail.vue?vue&type=script&lang=js"
import style0 from "./campaign-detail.vue?vue&type=style&index=0&id=e0813f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0813f3e",
  null
  
)

export default component.exports